var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 886.31,
    height: 554.3,
    viewBox: "0 0 886.31 554.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M612,104.38c14.84,0,41.22,10.71,41.22,42S640,216.09,640,260.6s54.41,97.28,54.41,179.72-42,164.06-42,164.06H571.6s-42-81.62-42-164.06S584,305.12,584,260.6s-13.19-82.85-13.19-114.18S597.16,104.38,612,104.38Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612,104.38c-4.74,0-13.19,10.71-13.19,42.05S603,216.09,603,260.6s-17.41,97.29-17.41,179.72,13.45,164.06,13.45,164.06H571.6s-42-81.62-42-164.06S584,305.12,584,260.6s-13.18-82.85-13.18-114.17S597.16,104.38,612,104.38Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M646.92,196.92c-1.75,10.05-3.51,20.56-4.83,31.53H581.93c-1.31-11-3.08-21.48-4.83-31.53Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.9,312.42H568.13c5.25-11.15,9.8-21.6,12.65-31.54h62.46C646.1,290.83,650.65,301.27,655.9,312.42Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M580.78,280.88H602c-.92,9.95-2.38,20.39-4.06,31.54H568.13C573.38,301.27,577.93,290.83,580.78,280.88Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#db4531"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.93,228.45c-1.31-11-3.08-21.48-4.83-31.53h23.74c.56,10.05,1.13,20.56,1.55,31.53Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#db4531"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M412,104.3c14.84,0,41.22,10.72,41.22,42.05S440,216,440,260.53s54.41,97.27,54.41,179.72-42,164-42,164H371.6s-42-81.62-42-164.06S384,305,384,260.53s-13.19-82.86-13.19-114.18S397.16,104.3,412,104.3Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,104.3c-4.74,0-13.19,10.71-13.19,42.05S403,216,403,260.53s-17.41,97.28-17.41,179.71S399.08,604.3,399.08,604.3H371.6s-42-81.62-42-164.06S384,305,384,260.53s-13.18-82.86-13.18-114.18S397.16,104.3,412,104.3Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.92,196.84c-1.75,10-3.51,20.56-4.83,31.53H381.93c-1.31-11-3.08-21.48-4.83-31.53Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.9,312.34H368.13c5.25-11.14,9.8-21.59,12.65-31.54h62.46C446.1,290.75,450.65,301.2,455.9,312.34Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M380.78,280.81H402c-.92,9.94-2.38,20.39-4.06,31.53H368.13C373.38,301.2,377.93,290.75,380.78,280.81Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#db4531"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.93,228.37c-1.31-11-3.08-21.48-4.83-31.53h23.74c.56,10,1.13,20.57,1.55,31.53Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#db4531"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,104c15.19,0,42.21,11,42.21,43.05S540.7,218.39,540.7,264s55.72,99.62,55.72,184-43.06,168-43.06,168H470.63s-43.05-83.58-43.05-168S483.3,309.56,483.3,264s-13.51-84.84-13.51-116.92S496.8,104,512,104Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,104c-4.86,0-13.51,11-13.51,43.06s4.33,71.33,4.33,116.91S485,363.59,485,448s13.78,168,13.78,168H470.63s-43.05-83.58-43.05-168S483.3,309.56,483.3,264s-13.5-84.84-13.5-116.91S496.81,104,512,104Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M547.76,198.76c-1.79,10.3-3.6,21.06-4.94,32.29H481.21c-1.34-11.23-3.15-22-4.95-32.29Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557,317H467.08c5.37-11.41,10-22.11,12.95-32.29h64C546.92,294.92,551.58,305.62,557,317Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480,284.74h21.75c-.94,10.18-2.43,20.88-4.16,32.29H467.08C472.45,305.62,477.11,294.92,480,284.74Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#db4531"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.21,231.05c-1.34-11.23-3.15-22-4.95-32.29h24.31c.57,10.3,1.16,21.06,1.59,32.29Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#db4531"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 164.06,
    cy: 390.25,
    r: 164.06,
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.42,494.25a164.11,164.11,0,0,1,129.2-160.34,164.06,164.06,0,1,0,0,320.67A164.1,164.1,0,0,1,123.42,494.25Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#333"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.32,433.55A15.62,15.62,0,1,1,328.7,420.6,15.76,15.76,0,0,1,313.32,433.55Z",
    transform: "translate(-53.71 -104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.47,451.58a15.62,15.62,0,1,1,15.39-12.95A15.77,15.77,0,0,1,263.47,451.58Z",
    transform: "translate(-53.71 -104)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306,474.41a15.62,15.62,0,1,1,15.39-13A15.78,15.78,0,0,1,306,474.41Z",
    transform: "translate(-53.71 -104)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M871.1,444.5,820.2,604.26H839c20.68,0,39-16.86,40.72-37.46L889.9,444.5Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.91,566.8,871.1,444.5h-141l1.56,18.8H727a47,47,0,1,0,0,94h12.53l.79,9.53c1.72,20.6,20,37.46,40.71,37.46H820.2C840.87,604.26,859.19,587.4,860.91,566.8ZM727,538.48a28.2,28.2,0,1,1,0-56.39h6.26l4.7,56.39Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc6e3d"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M825.68,408.48c0-7.42,1.91-10.92,4.13-15,2.47-4.53,5.27-9.67,5.27-19.48s-2.8-14.95-5.27-19.48h0a4.7,4.7,0,0,0-8.25,4.5h0c2.21,4.06,4.12,7.56,4.12,15s-1.91,10.92-4.12,15c-2.48,4.53-5.28,9.66-5.28,19.48s2.8,14.94,5.28,19.48a4.7,4.7,0,0,0,8.25-4.51C827.59,419.4,825.68,415.89,825.68,408.48Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#e4ada0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.35,408.48c0-7.42,1.92-10.92,4.13-15,2.47-4.53,5.27-9.67,5.27-19.48s-2.8-14.95-5.27-19.48h0a4.7,4.7,0,0,0-8.25,4.5h0c2.21,4.06,4.13,7.56,4.13,15s-1.92,10.92-4.13,15c-2.47,4.53-5.27,9.66-5.27,19.48s2.8,14.94,5.27,19.48a4.7,4.7,0,0,0,8.25-4.51C796.27,419.4,794.35,415.89,794.35,408.48Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#e4ada0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M915,623.05l-25.06,18.8h18.79c10.34,0,21.47-8,24.74-17.83l.32-1Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#ef431d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.64,624l.32-1H686.28l.32,1c3.27,9.81,14.41,17.83,24.74,17.83H889.9C900.23,641.85,911.37,633.83,914.64,624Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#fc583d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.32,627.75H684.72a4.7,4.7,0,1,1,0-9.39h250.6a4.7,4.7,0,1,1,0,9.39Z",
    transform: "translate(-53.71 -104)",
    style: {
      fill: "#b4462f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 793.27,
    cy: 457.97,
    r: 4.7,
    style: {
      fill: "#fd7555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774.48,
    cy: 476.76,
    r: 4.7,
    style: {
      fill: "#fd7555"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.bf29311e750716e428f5bb18442f302b.svg";
export { ForwardRef as ReactComponent };